import { render, staticRenderFns } from "./indexTable.vue?vue&type=template&id=6381572e"
import script from "./indexTable.vue?vue&type=script&lang=js"
export * from "./indexTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports